import { useSearchParams } from 'react-router-dom'

export const ConcentTemplatePage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const sign_path = searchParams.get('sign_path')
  const created = searchParams.get('created')
  const full_name = searchParams.get('full_name')

  return (
    <div
      style={{
        margin: '30px',
      }}
    >
      <h1>
        Dématérialisation des documents, signatures, courriers (consentement)
      </h1>
      <p>
        <b>
          Consentement à l’utilisation de documents dématérialisés Manda
          (Ex-Hello Syndic)
        </b>
        <b>
          J’accepte l’utilisation des données limitées aux activités décrites et
          l’utilisation du format dématérialisée pour l’ensemble des documents
          (courriers, appels de fonds, courriers recommandés ou remises contre
          signatures, notamment mises en demeures, convocations,
          procès-verbaux).
        </b>
        J’ai accepté expressément de recevoir l'ensemble des documents par voie
        électronique (par mail simple, par remise contre signature, ou par
        recommandé électronique.
        <br />
        Dans le cadre de la gestion de la copropriété, j’ai noté que je
        consentais à communiquer noms, adresses e-mails et numéro de téléphone
        dans le cadre de l'activité. Il est exclu que ces données soient
        transmises à une autre entreprise à des fins commerciales. J’ai noté que
        ces données et préférences sont modifiables à tout moment sur simple
        demande ou sur l'interface client disponible sur internet et sur
        smartphone.
        <br />
        <br />
      </p>
      <p>
        J’ai noté les informations suivantes : Les informations recueillies sur
        ce formulaire sont enregistrées dans un fichier informatisé par Hello
        Syndic dans le cadre du contrat qui lie les copropriétaires à Hello
        Syndic. Les données collectées seront communiquées aux seuls
        destinataires suivants : Manda (Ex-Hello Syndic), ou toute société
        mandatée dans le cadre d'une intervention dans le cadre de l'activité de
        Manda (Ex-Hello Syndic). Vous pouvez retirer à tout moment votre
        consentement au traitement de vos données. Vous pouvez également vous
        opposer au traitement de vos données. Vous pouvez également exercer
        votre droit à la portabilité de vos données. Consultez le site cnil.fr
        pour plus d'informations sur vos droits. Pour exercer ces droits ou pour
        toute question sur le traitement de vos données dans ce dispositif, vous
        pouvez contacter copro@manda.fr ou via Manda (Ex-Hello Syndic), 73
        Avenue du Roule, 92200 Neuilly-sur-Seine
        <br />
        <br />
        Vous pouvez accéder aux données vous concernant, les rectifier, demander
        leur effacement ou exercer votre droit à la limitation du traitement de
        vos données.
        <br />
        <br />
      </p>
      <div>
        <span>{created}</span>
        <br />
        <img
          style={{
            maxWidth: '250px',
          }}
          src={sign_path}
        />
        <br />
        <span>{full_name}</span>
      </div>
    </div>
  )
}
